import React, { Component } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

class enquiryDetail extends Component {

     constructor(props) {
        super(props);
        
        this.state = {
            lead:"",
            openModal:false,
            checkMailContent:false,
            fetchedPartnerListHTML:'',
            lead_data:[],
            maillist:[],
            partnerlist:[],
            manualpartnerlist:[],
            partners_f:[],
            created_date:"",
            confirmnodataregret:false,
            distance:'',
            modetype:'',
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
        }
           
        this.lead_id = this.props.match.params.id ? this.props.match.params.id : '';
        if (this.lead_id !== undefined) {
            
            this.enquiryDetail(this.lead_id);
       

        }
        
        this.enquiryDetail = this.enquiryDetail.bind(this);
     

    }
    
    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };
  
 

    async enquiryDetail(lead_id) {

          let response = await FetchCall.getEnqDetail(lead_id);
          if (response.status === 1) {

            this.setState({
                    lead_id: response.detail.id,
                    lead_number:response.detail.lead_number,
                    firstname: response.detail.firstname,
                    lead_status: response.detail.lead_status,
                    city: response.detail.city,
                    lastname: response.detail.lastname,
                    email:response.detail.email,
                    grades:response.detail.grades,
                    subcategory:response.detail.subcategory,
                    subcategory_text:response.detail.subcategory_text,
                    mobilenumber:response.detail.mobilenumber,
                    created_date: new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(response.detail.created_date),
                    lead_data: response.detail.lead_data ? JSON.parse(response.detail.lead_data) : [],
                    location: response.detail.location,
                    city:response.detail.city,
                    lead_vertical: response.detail.lead_vertical,
                    accepttakingcalls:response.detail.accepttakingcalls,
                    searchkey: response.detail.searchkey,
                    user_id:response.detail.user_id
            })

            if(response.detail.searchkey){
                    let cat_detail = await FetchCall.getCategoryDetail(response.detail.searchkey);

                    if (cat_detail.status === 1) {

                        this.setState({subvertical:cat_detail.results[0].category_name});

                        let subcategory = await FetchCall.getCategoryDetail(response.detail.subcategory);
                        if (subcategory.status === 1) {
                            this.setState({subcategory_text:subcategory.results[0].category_name});
                        }

                    }
                
            }

          }


    }
           

    renderUsers() {
          const userList = [];
  
                for(let i = 0; i < this.state.partnerlist.length; i++) {
                    
                          userList.push(<tr class="table-info">
                                          <td><a href={(this.state.partnerlist[i].partner_link==null)?"#":"https://bewise.in"+this.state.partnerlist[i].partner_link} target="_blank">{this.state.partnerlist[i].partner_name}</a></td>
                                          { /* <td> {this.state.partnerlist[i].user_type==1?"Institute":"Individual"}</td> */ }
                                          <td> {this.state.partnerlist[i].seen==1?"Yes":"No"}</td>
                                          <td>{this.state.partnerlist[i].seen_mobilenumber==1?"Yes":"No"}</td>
                                          <td> {this.state.partnerlist[i].seen_emailid==1?"Yes":"No"}</td>
                                      </tr>);
                }
    
          return userList;
    }     
        

    componentDidMount() {

        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        this.setState({ vendor_id: vendor_id });
       
    }


    render() {

         const {lead_id, lead_number, lead_status, 
                email, 
                mobilenumber, 
                lead_data, 
                firstname, 
                lastname, 
                lead_vertical, 
                grades,
                searchkey, 
                subcategory_text,
                subvertical,
                subcategory,
                location, 
                city, 
                accepttakingcalls, 
                created_date, 
                partnerlist,
                manualpartnerlist,
                message,
                user_id} = this.state;


        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Enquiries </h4>

                    <a href="/enquiry/enquiries" class="btn btn-sm btn-primary">Back to list</a>
                 
                    <div class="leadpage">

                    <div class="d-flex justify-content-between align-items-center py-3">
                      <h2 class="h5 mb-0"><a href="#" class="text-muted"></a> Lead Ref# :{lead_number}</h2>
                    </div>

                    <div class="row">
                  <div class="col-lg-8">
              
                    <div class="card mb-4">
                      <div class="card-body">
                        <div class="mb-3 d-flex justify-content-between">
                          <div>
                            <span class="me-3">Created Date: {created_date}&nbsp;</span>
                          
                          </div>
                          
                        </div>
                        
                        <div>
                              <label>Enquiry Detail</label>
                              
                                  
                              <div class="enqinfoblock">

                                  <div>Name: <span>{firstname} {lastname}</span></div>
                                  <div>Mobilenumber: <span>{mobilenumber}</span></div>
                                  <div>Email: <span>{email}</span></div>
                                  <div>Message: <span>{message}</span></div>

                              </div>
                         
                       
                      </div>
                    </div>
                  

                  </div>
                 
                    </div>

                    </div>
                
                    </div>
 
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default enquiryDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/enquiryDetail.jsx